import { useContext } from 'react';
import { parseLicense } from '../../shared/types/license';
import { LicenseContext, NOT_ENFORCED, type LicenseApi } from './LicenseContext';

export function useLicense(): LicenseApi {
  return useContext(LicenseContext);
}

/** `data` = conteudo do doc (null se nao existe). So `aplicar` valido tem efeito. */
export function buildLicenseApi(data: unknown, loaded: boolean): LicenseApi {
  const lic = parseLicense(data);
  const cut = lic?.status === 'cancelada';
  if (!lic || lic.enforcement !== 'aplicar') return { ...NOT_ENFORCED, loaded, cut };
  return {
    loaded,
    enforced: true,
    canUse: (m) => lic.modules[m] !== 'ausente',
    canWrite: (m) => lic.modules[m] === 'contratado' && lic.status === 'ativa',
    clinicReadOnly: lic.status !== 'ativa',
    botLimits: lic.botLimits,
    cut,
  };
}
